import { useContext, useState } from "react";
import { toast } from "react-toastify";
import { PitchContext } from "../context/PitchContex";
import axios from "axios";
import { Link } from "react-router-dom";

const CommentSection = ({ reviews, pitchID, setReviewSubmit }) => {
  const {
    user,
    backendURL,
    token,
    setAlertMessage,
    setShowAlert,
    setIsErr,
    setPending,
  } = useContext(PitchContext);
  const [newComment, setNewComment] = useState({
    rating: 0,
    text: "",
    isAnonymous: false, // Added anonymous flag
  });

  // Handle input changes
  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setNewComment((prev) => ({
      ...prev,
      [name]:
        type === "checkbox"
          ? checked
          : name === "rating"
          ? parseInt(value)
          : value,
    }));
  };

  // Handle form submission
  const handleSubmit = (e) => {
    e.preventDefault();
    if (!newComment.text || newComment.rating === 0) {
      setShowAlert(true);
      setIsErr(true);
      setAlertMessage("Lütfen puan ve yorum kısmını boş bırakmayınız.");

      return;
    }
    setPending(true);
    const review = {
      userID: user._id,
      pitchID,
      content: newComment.text,
      rating: newComment.rating,
      isAnonymous: newComment.isAnonymous, // Added to review object
    };

    axios
      .post(backendURL + "review/create", review)
      .then((response) => {
        setPending(false);
        setShowAlert(true);
        setIsErr(false);
        setAlertMessage(response.data.message);
        setReviewSubmit((prev) => !prev);
      })
      .catch((err) => {
        setPending(false);
        console.log(err);
        toast.error(err.response.data.message, { autoClose: 2000 });
      });
    setPending(false);
    setNewComment({ rating: 0, text: "", isAnonymous: false });
  };

  return (
    <div className="w-full mx-auto bg-white p-6 rounded-2xl border border-gray-200">
      {/* Add Comment Section */}
      <div className="mt-8 border-gray-200 mb-10">
        <h3 className="text-xl font-semibold text-gray-800 mb-4">
          Değerlendirmenizi Ekleyin
        </h3>
        <form onSubmit={handleSubmit} className="space-y-4">
          {/* Rating Field */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Puan
            </label>
            <div className="flex items-center gap-2">
              {Array.from({ length: 5 }, (_, i) => (
                <span
                  key={i}
                  onClick={() =>
                    setNewComment((prev) => ({ ...prev, rating: i + 1 }))
                  }
                  className={`text-2xl cursor-pointer transition-colors duration-200 ${
                    i < newComment.rating ? "text-yellow-400" : "text-gray-300"
                  } hover:text-yellow-500`}
                >
                  ★
                </span>
              ))}
            </div>
          </div>

          {/* Comment Text Field */}
          <div>
            <label
              htmlFor="text"
              className="block text-sm font-medium text-gray-700 mb-1"
            ></label>
            <textarea
              id="text"
              name="text"
              value={newComment.text}
              onChange={handleInputChange}
              className="w-full p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#6ca87e] focus:border-transparent"
              rows="4"
              placeholder="Değerlendirmenizi buraya yazın"
              required
            />
          </div>

          {/* Anonymous Checkbox */}
          <div className="flex items-center">
            <input
              type="checkbox"
              id="isAnonymous"
              name="isAnonymous"
              checked={newComment.isAnonymous}
              onChange={handleInputChange}
              className="h-4 w-4 text-[#4d9041] focus:ring-[#62a556] border-gray-300 rounded"
            />
            <label
              htmlFor="isAnonymous"
              className="ml-2 block text-sm text-gray-700"
            >
              Gizli yayınla
            </label>
          </div>

          {/* Submit Button */}
          {token ? (
            <div className="">
              {user.verified ? (
                <button
                  type="submit"
                  className="w-full bg-[#4d9041] text-white py-2 px-4 rounded-lg hover:bg-[#62a556] transition-colors duration-200 cursor-pointer"
                >
                  Gönder
                </button>
              ) : (
                <div className="grid place-items-center text-red-500">
                  <p>Yorum yapmak için e-postanızı doğrulayın</p>
                </div>
              )}
            </div>
          ) : (
            <Link to={"/giris-yap"}>
              <button className="w-full bg-[#4d9041] text-white py-2 px-4 rounded-lg hover:bg-[#62a556] transition-colors duration-200 cursor-pointer">
                Değerlendirme yapmak için giriş yapın
              </button>
            </Link>
          )}
        </form>
      </div>

      {/* Existing Reviews */}
      <h2 className="text-2xl font-bold text-gray-800 mb-6 tracking-tight">
        Kullanıcı Değerlendirmeleri
      </h2>
      {reviews && reviews.length > 0 ? (
        reviews.map((comment, index) => (
          <div
            key={index}
            className="border-b border-gray-200 pb-4 mb-4 last:border-b-0 transition-all duration-200 hover:bg-gray-50 rounded-lg px-2"
          >
            <div className="flex items-center justify-between mb-3">
              <p className="font-semibold text-gray-800 text-lg">
                {comment.isAnonymous
                  ? "Gizli Kullanıcı"
                  : comment.userID.fullname}
              </p>
              <p className="text-gray-500 text-sm italic">
                {new Date(comment.createdAt).toLocaleString("tr-TR", {
                  year: "numeric",
                  month: "short",
                  day: "numeric",
                  hour: "2-digit",
                  minute: "2-digit",
                })}
              </p>
            </div>
            <div className="flex items-center mb-3">
              {Array.from({ length: 5 }, (_, i) => (
                <span
                  key={i}
                  className={`text-lg transition-colors duration-200 ${
                    i < comment.rating ? "text-yellow-400" : "text-gray-300"
                  }`}
                >
                  ★
                </span>
              ))}
              <span className="ml-2 text-gray-600 text-sm font-medium">
                {comment.rating.toFixed(1)} {/* Changed to show one decimal */}
              </span>
            </div>
            <p className="text-gray-700 leading-relaxed">{comment.content}</p>
          </div>
        ))
      ) : (
        <p className="text-gray-500 text-center py-4">
          Henüz deġerlendirme yok. İlk deġerlendirmeyi yapan siz olun!
        </p>
      )}
    </div>
  );
};

export default CommentSection;
